import { Heading, Text } from '@chakra-ui/react';

export const ReferralTabHeader = ({ title, subtitle }) => (
  <>
    <Heading as="h4" size={{ base: 'sm', md: 'md' }} mb={1}>
      {title}
    </Heading>
    <Text fontSize={{ base: 'sm', md: 'md' }} mb={10}>
      {subtitle}
    </Text>
  </>
);
